import { render, staticRenderFns } from "./portal-nav.vue?vue&type=template&id=4c854992&scoped=true&"
import script from "./portal-nav.vue?vue&type=script&lang=js&"
export * from "./portal-nav.vue?vue&type=script&lang=js&"
import style0 from "./portal-nav.vue?vue&type=style&index=0&id=4c854992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c854992",
  null
  
)

export default component.exports